import React from "react";
import styles from "./CreateUserFormView.module.scss";
import MessageCard from "../../../../../common/components/molecule/MessageCard/MessageCard";
import { UserRole, userRoles, UserStatus } from "../../../types/user.types";
import { UserErrorState, UserFormData } from "../CreateUserForm";
import TextInput from "../../../../../common/components/atom/TextInput/TextInput";
import Button from "../../../../../common/components/atom/Button/Button";
import SelectInput from "../../../../../common/components/atom/SelectInput/SelectInput";

export interface CreateUserFormProps {
  formData?: UserFormData;
  setFormData: (key: keyof UserFormData, value: string) => void;
  errorStatus?: UserErrorState;
  handleSubmit?: () => void;
  messageError?: string | null;
  isLoading?: boolean;
  submitLabel?: string;
  description?: string;
  title?: string;
  maxWidth?: string;
  currentUserRoleCreator?: UserRole;
  organizationPickerComponent?: React.ReactNode;
}
export default function CreateUserFormView({
  handleSubmit,
  messageError,
  errorStatus,
  isLoading,
  submitLabel = "Créer",
  description = "Saisissez les informations de l'utilisateur",
  maxWidth = "700px",
  title,
  formData,
  setFormData,
  currentUserRoleCreator = userRoles.USER,
  organizationPickerComponent,
}: CreateUserFormProps) {
  const optionsRole: { label: string; value: UserRole }[] = [
    {
      label: "Administrateur",
      value: userRoles.ADMIN,
    },
    {
      label: "Super Administrateur",
      value: userRoles.SUPER_ADMIN,
    },
    {
      label: "Utilisateur",
      value: userRoles.USER,
    },
  ];

  const optionsUserStatus: { label: string; value: UserStatus }[] = [
    {
      label: "Activé",
      value: "ACTIVATED",
    },
    {
      label: "Désactivé",
      value: "DESACTIVATED",
    },
  ];

  const optionsRoleFormated = optionsRole.filter(
    (option: { label: string; value: UserRole }) =>
      option.value <= currentUserRoleCreator
  );

  return (
    <div style={{ maxWidth: maxWidth }}>
      <div className={[styles["container"]].join(" ")}>
        {title && (
          <h1 className={[styles["container__title"]].join(" ")}>{title}</h1>
        )}
        <p className={[styles["container__description"]].join(" ")}>
          {description}
        </p>
        <div className={[styles["container__error-message"]].join(" ")}>
          <MessageCard variant="danger" message={messageError} width100 />
        </div>
        <form
          className={[styles["form"]].join(" ")}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit && handleSubmit();
          }}
        >
          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label={"Nom"}
              value={formData?.lastName}
              error={errorStatus?.isErrorLastName}
              onChange={(e) => {
                const value = e.target.value;

                setFormData("lastName", value);
              }}
            />
          </div>
          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label={"Prénom"}
              value={formData?.firstName}
              error={errorStatus?.isErrorFirstName}
              onChange={(e) => {
                const value = e.target.value;

                setFormData("firstName", value);
              }}
            />
          </div>
          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label={"Email"}
              value={formData?.email}
              error={errorStatus?.isErrorEmail}
              onChange={(e) => {
                const value = e.target.value;
                setFormData("email", value);
              }}
              type="email"
            />
          </div>

          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label={"Numéro de téléphone"}
              value={formData?.numberPhone}
              error={errorStatus?.isErrorNumberPhone}
              onChange={(e) => {
                const value = e.target.value;
                setFormData("numberPhone", value);
              }}
            />
          </div>
          <div className={[styles["form__item"]].join(" ")}>
            <SelectInput
              label={"Genre"}
              value={formData?.gender}
              error={errorStatus?.isErrorGender}
              handleChange={(value) => {
                setFormData("gender", value);
              }}
              options={[
                {
                  value: "FEMALE",
                  label: "Femme",
                },
                {
                  value: "MALE",
                  label: "Homme",
                },
              ]}
            />
          </div>

          {organizationPickerComponent &&
            currentUserRoleCreator >= userRoles.SUPER_ADMIN && (
              <div className={[styles["form__item"]].join(" ")}>
                {organizationPickerComponent}
              </div>
            )}

          <div className={[styles["form__item"]].join(" ")}>
            <SelectInput
              label={"Rôle"}
              value={formData?.role}
              error={errorStatus?.isErrorRole}
              handleChange={(value) => {
                setFormData("role", value);
              }}
              options={[...optionsRoleFormated]}
            />
          </div>

          <div className={[styles["form__item"]].join(" ")}>
            <SelectInput
              label={"Statut"}
              value={formData?.status}
              error={errorStatus?.isErrorStatus}
              handleChange={(value) => {
                setFormData("status", value);
              }}
              options={[...optionsUserStatus]}
            />
          </div>

          <div className={[styles["form__button-container"]].join(" ")}>
            <div className={[styles["form__button-container__item"]].join(" ")}>
              <Button
                isLoading={isLoading}
                onClick={handleSubmit}
                type={"submit"}
              >
                {submitLabel}
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
